import Dashboard from '../components/dashboard/Dashboard';
import { useApp } from '../context/AppContext';
import TaskModal from '../components/task/TaskModal';

import { PageTitle } from '../../../../_metronic/layout/core';

export default function DashboardPage() {
  const { state, dispatch } = useApp();
  const selectedTask = state.tasks.find(t => t.id === state.selectedTaskId);

  return (
    <>
      <PageTitle>DevOps - Dashboard</PageTitle>
      <Dashboard />
      {selectedTask && (
        <TaskModal
          task={selectedTask}
          onClose={() => dispatch({ type: 'SELECT_TASK', payload: null })}
        />
      )}
    </>
  );
}
